import { BasePortalCD } from "./constants";
import CryptoJS from "crypto-js";
const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;

export const getTokenExID = () => {
  const tokenExId = {
    QA: "8195444713621244",
    PRODUCTION: "7219578950671884",
    STAGING: "7219578950671884",
    DEVELOPMENT: "8195444713621244",
  };
  return tokenExId[currentEnv];
};
export const getTokenExSecretKey = () => {
  const tokenExSecretKey = {
    QA: "rXB4vnU6VV1FMIiPC5fPaIbame36vyET6RN8HIeW",
    PRODUCTION: "JEbKQopuB2RCYguHAWBwG2vi8tDgz5oCsD9ZMdcP",
    STAGING: "JEbKQopuB2RCYguHAWBwG2vi8tDgz5oCsD9ZMdcP",
    DEVELOPMENT: "rXB4vnU6VV1FMIiPC5fPaIbame36vyET6RN8HIeW",
  };
  return tokenExSecretKey[currentEnv];
};
export const getTokenExScheme = () => {
  return "nTOKENfour";
};
export const getTokenExApiKey = () => {
  const tokenExApiKey = {
    QA: "ZcSNit6Ws8g37fNu2ceE9xCXj0VMusoCJ49kXAfA",
    PRODUCTION: "tRj39D0PShGDYMXB0ySStF6cQa3WHTLI4h76krrg",
    STAGING: "tRj39D0PShGDYMXB0ySStF6cQa3WHTLI4h76krrg",
    DEVELOPMENT: "ZcSNit6Ws8g37fNu2ceE9xCXj0VMusoCJ49kXAfA",
  };
  return tokenExApiKey[currentEnv];
};
export const getTokenExJsURL = () => {
  const tokenExJsURL = {
    QA: "https://test-htp.tokenex.com/Iframe/Iframe-v3.min.js",
    PRODUCTION: "https://htp.tokenex.com/Iframe/Iframe-v3.min.js",
    STAGING: "https://htp.tokenex.com/Iframe/Iframe-v3.min.js",
    DEVELOPMENT: "https://test-htp.tokenex.com/Iframe/Iframe-v3.min.js",
  };
  return tokenExJsURL[currentEnv];
};
export const getBasePortal = (portalCD) => {
  let portal = "PS";
  if (portalCD.indexOf("WSRB") > -1) {
    portal = "WSRB";
  } else if (portalCD.indexOf("SS") > -1) {
    portal = "SS";
  } else if (portalCD.indexOf("LS") > -1) {
    portal = "LS";
  }
  return portal;
};
export const getPaypalHostUrl = () => {
  const paypalHostUrl = {
    QA: "https://api-m.sandbox.Paypal.com",
    PRODUCTION: "https://api-m.paypal.com",
    STAGING: "https://api-m.paypal.com",
    DEVELOPMENT: "https://api-m.sandbox.Paypal.com",
  };
  return paypalHostUrl[currentEnv];
};
export const getPaypalClientId = (portalCD) => {
  const PS_payPalClientId = {
    QA: "ATugdDsikls73mjScPGJAhmlNmDabn62NNhDwd2x-awviSlTDUfN0cGAwFYYrca2sfrEsL5NYHTpq4I2",
    PRODUCTION: "AfLQPD_h4G_JwwuUhxhkNfGM5-4EJuzuj4KlBe2jmklriAVfVJn0g79Dp-tf1tRkCHel0xPFpg_ijv7-",
    STAGING: "AfLQPD_h4G_JwwuUhxhkNfGM5-4EJuzuj4KlBe2jmklriAVfVJn0g79Dp-tf1tRkCHel0xPFpg_ijv7-",
    DEVELOPMENT: "ATugdDsikls73mjScPGJAhmlNmDabn62NNhDwd2x-awviSlTDUfN0cGAwFYYrca2sfrEsL5NYHTpq4I2",
  };
  const RB_paypalClientId = {
    QA: "AS3U8jK4BzOmWOLwZWPUuxes_bp2D0d58moSXmSD-psi2cYR-g6-s9xi-Hl36sc6Bb1t-LEgT4pPqW-J",
    PRODUCTION: "AW4HnSaQDihQ7flT9RRBvNzV0PTkUT-D_Ry0vLZTsLi08ALdYGyb47jYT48ixFjZQfnF4hq_x9uCENRz",
    STAGING: "AW4HnSaQDihQ7flT9RRBvNzV0PTkUT-D_Ry0vLZTsLi08ALdYGyb47jYT48ixFjZQfnF4hq_x9uCENRz",
    DEVELOPMENT: "AS3U8jK4BzOmWOLwZWPUuxes_bp2D0d58moSXmSD-psi2cYR-g6-s9xi-Hl36sc6Bb1t-LEgT4pPqW-J",
  };
  const SS_paypalClientId = {
    QA: "AfASyq8gOj3sHtBllrg2ttjud0eD9pByjEwuYx0Rvy33pEA-BQWKfD89qD_kPTP2_z0_aeRsSp7ZhGZz",
    PRODUCTION: "AWFv9k6TOxZetFBK-xLEyp6FnzwZApLm1MpjrQ-yfNUMl38ku3I5i0h5zXBC56-JWJRNrbM73KLNkef0",
    STAGING: "AWFv9k6TOxZetFBK-xLEyp6FnzwZApLm1MpjrQ-yfNUMl38ku3I5i0h5zXBC56-JWJRNrbM73KLNkef0",
    DEVELOPMENT: "AfASyq8gOj3sHtBllrg2ttjud0eD9pByjEwuYx0Rvy33pEA-BQWKfD89qD_kPTP2_z0_aeRsSp7ZhGZz",
  };
  const LS_paypalClientId = {
    QA: "AQ0mec9hWOXF3JMIQDX8S9FZtOb8F6KhNAdCso3R8gHWo7VnXdLzKTs4RuEsXf7jggPiST7PyvSmtzNo",
    PRODUCTION: "AQ0mec9hWOXF3JMIQDX8S9FZtOb8F6KhNAdCso3R8gHWo7VnXdLzKTs4RuEsXf7jggPiST7PyvSmtzNo",
    STAGING: "AQ0mec9hWOXF3JMIQDX8S9FZtOb8F6KhNAdCso3R8gHWo7VnXdLzKTs4RuEsXf7jggPiST7PyvSmtzNo",
    DEVELOPMENT: "AQ0mec9hWOXF3JMIQDX8S9FZtOb8F6KhNAdCso3R8gHWo7VnXdLzKTs4RuEsXf7jggPiST7PyvSmtzNo",
  };
  var currentPortal = getBasePortal(portalCD);
  switch (currentPortal) {
    case BasePortalCD.PS:
      return PS_payPalClientId[currentEnv];
    case BasePortalCD.WSRB:
      return RB_paypalClientId[currentEnv];
    case BasePortalCD.SS:
      return SS_paypalClientId[currentEnv];
    case BasePortalCD.LSEN:
      return LS_paypalClientId[currentEnv];
    default:
      return "";
  }
};

export const getPaypalClientSecret = (portalCD) => {
  const PS_paypalClientSecret = {
    QA: "EHr1DXWqQeN6HrT2cUsS2UsP1ohddB2jQzu3OX1ZU2aWSznLAtaCU5XlwwWcu8RdeJtN_RUm5-hpUy9z",
    PRODUCTION: "EAnUQbpqOkqYxA928tRM0yCID8gHPaZpb_8JYpMNtEtxXzH-Szfmo_XD-AKC6KQSZFbNnZh-GmaY3v8r",
    STAGING: "EAnUQbpqOkqYxA928tRM0yCID8gHPaZpb_8JYpMNtEtxXzH-Szfmo_XD-AKC6KQSZFbNnZh-GmaY3v8r",
    DEVELOPMENT: "EHr1DXWqQeN6HrT2cUsS2UsP1ohddB2jQzu3OX1ZU2aWSznLAtaCU5XlwwWcu8RdeJtN_RUm5-hpUy9z",
  };
  const RB_paypalClientSecret = {
    QA: "EHAoKTvJgU5i0Ywli8A29CmGBwhKDzJkpsnAUqWn4-bFphNyEuokOcjT_NwS_8bZgzxkofGw4bRqsV0x",
    PRODUCTION: "EGvvLaMcnI-r5kwbGUGf2gMXSGIazT7IehWAl78ljCGt3DEnL7aqiFiaZe3WNAJyaj8wnv1DzCPl7cHa",
    STAGING: "EGvvLaMcnI-r5kwbGUGf2gMXSGIazT7IehWAl78ljCGt3DEnL7aqiFiaZe3WNAJyaj8wnv1DzCPl7cHa",
    DEVELOPMENT: "EHAoKTvJgU5i0Ywli8A29CmGBwhKDzJkpsnAUqWn4-bFphNyEuokOcjT_NwS_8bZgzxkofGw4bRqsV0x",
  };
  const SS_paypalClientSecret = {
    QA: "ECQ-3Eb1cQTU-N3Rm93IefJyCA2FgNDwfRLTdyIEWdUTb5tL0YAvJ-v-HK4RRmOgTQaRLsDj-LDCQngT",
    PRODUCTION: "EJrnLFYDduypgxt61HXuOZK_tHmCOJin8PHUdXbTJ_OGete6qkJUDKRr7YMlK4nqpww3qepA5thy2320",
    STAGING: "EJrnLFYDduypgxt61HXuOZK_tHmCOJin8PHUdXbTJ_OGete6qkJUDKRr7YMlK4nqpww3qepA5thy2320",
    DEVELOPMENT: "ECQ-3Eb1cQTU-N3Rm93IefJyCA2FgNDwfRLTdyIEWdUTb5tL0YAvJ-v-HK4RRmOgTQaRLsDj-LDCQngT",
  };
  const LS_paypalClientSecret = {
    QA: "EEzGFxqxdKFHT_ko7RlIK3V6wVHIeLbw5wHm39z0i1Ioy7mp9pO4EFp9JAJg2ARySZ2Y-4ygEMU9MTZ2",
    PRODUCTION: "EEzGFxqxdKFHT_ko7RlIK3V6wVHIeLbw5wHm39z0i1Ioy7mp9pO4EFp9JAJg2ARySZ2Y-4ygEMU9MTZ2",
    STAGING: "EEzGFxqxdKFHT_ko7RlIK3V6wVHIeLbw5wHm39z0i1Ioy7mp9pO4EFp9JAJg2ARySZ2Y-4ygEMU9MTZ2",
    DEVELOPMENT: "EEzGFxqxdKFHT_ko7RlIK3V6wVHIeLbw5wHm39z0i1Ioy7mp9pO4EFp9JAJg2ARySZ2Y-4ygEMU9MTZ2",
  };
  var currentPortal = getBasePortal(portalCD);
  switch (currentPortal) {
    case BasePortalCD.PS:
      return PS_paypalClientSecret[currentEnv];
    case BasePortalCD.WSRB:
      return RB_paypalClientSecret[currentEnv];
    case BasePortalCD.SS:
      return SS_paypalClientSecret[currentEnv];
    case BasePortalCD.LSEN:
      return LS_paypalClientSecret[currentEnv];
    default:
      return "";
  }
};

export const getChargBeeSiteName = () => {
  const chargeBeeSiteName = {
    QA: "pdfsimpli-test",
    PRODUCTION: "pdfsimpli",
    STAGING: "pdfsimpli",
    DEVELOPMENT: "pdfsimpli-test",
  };
  return chargeBeeSiteName[currentEnv];
};
export const getChargBeeUserName = () => {
  const chargBeeUserName = {
    QA: "test_a522ubcua6nw6iEd5Y1VqRl87jY09q9Z3",
    PRODUCTION: "live_P7AGY9QJAvP0c5lXHku5LoVuT7RudUR9",
    STAGING: "live_P7AGY9QJAvP0c5lXHku5LoVuT7RudUR9",
    DEVELOPMENT: "test_a522ubcua6nw6iEd5Y1VqRl87jY09q9Z3",
  };
  return chargBeeUserName[currentEnv];
};

export const getGateWayIdfor3DSCheckout = () => {
  const gtwayId = {
    QA: "gw_Azqgj2Rt6Wc0U5xm",
    PRODUCTION: "gw_Azq9YyTf3P8zU41Ka",
    STAGING: "gw_Azq9YyTf3P8zU41Ka",
    DEVELOPMENT: "gw_Azqgj2Rt6Wc0U5xm",
  };
  return gtwayId[currentEnv];
};
export const getKountKey = () => {
  const kountKey = {
    QA: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiIxMDE0NTIiLCJhdWQiOiJLb3VudC4xIiwiaWF0IjoxNjkwMTg4OTg2LCJzY3AiOnsia2EiOm51bGwsImtjIjpudWxsLCJhcGkiOnRydWUsInJpcyI6dHJ1ZSwidGRzIjpudWxsfX0.TZumbcVr194vAIQ-CJS2C08HnltKlOvhZ7fPQZGt_no",
    PRODUCTION:
      "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiIxMDE0NTIiLCJhdWQiOiJLb3VudC4xIiwiaWF0IjoxNjk1MDUyNDUzLCJzY3AiOnsia2EiOm51bGwsImtjIjpudWxsLCJhcGkiOnRydWUsInJpcyI6dHJ1ZSwidGRzIjpudWxsfX0.RF6sjRq39vcOzJluTp244oVkO07m4zEjofs-9_sf4SY",
    STAGING:
      "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiIxMDE0NTIiLCJhdWQiOiJLb3VudC4xIiwiaWF0IjoxNjk1MDUyNDUzLCJzY3AiOnsia2EiOm51bGwsImtjIjpudWxsLCJhcGkiOnRydWUsInJpcyI6dHJ1ZSwidGRzIjpudWxsfX0.RF6sjRq39vcOzJluTp244oVkO07m4zEjofs-9_sf4SY",
    DEVELOPMENT:
      "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiIxMDE0NTIiLCJhdWQiOiJLb3VudC4xIiwiaWF0IjoxNjkwMTg4OTg2LCJzY3AiOnsia2EiOm51bGwsImtjIjpudWxsLCJhcGkiOnRydWUsInJpcyI6dHJ1ZSwidGRzIjpudWxsfX0.TZumbcVr194vAIQ-CJS2C08HnltKlOvhZ7fPQZGt_no",
  };
  return kountKey[currentEnv];
};
export const getkountEnableOrNot = () => {
  const isKountEnable = {
    QA: "true",
    PRODUCTION: "true",
    STAGING: "true",
    DEVELOPMENT: "true",
  };
  return isKountEnable[currentEnv];
};
export const kountVersion = "0720";
export const kountMerchantId = "101452";
export const KountTransactionSite = "DEFAULT";
export const greCaptchaAction = (portalCD) => {
  var currentPortal = getBasePortal(portalCD);
  switch (currentPortal) {
    case BasePortalCD.PS:
      return "submit";
    case BasePortalCD.WSRB:
      return "payment";
    case BasePortalCD.SS:
      return "payment";
    default:
      return "";
  }
};

export const getCyberSourceJsURL = () => {
  const cyberSourceJsURL = {
    QA: "https://flex.cybersource.com/cybersource/assets/microform/0.11/flex-microform.min.js",
    PRODUCTION: "",
    STAGING: "",
    DEVELOPMENT: "https://flex.cybersource.com/cybersource/assets/microform/0.11/flex-microform.min.js",
  };
  return cyberSourceJsURL[currentEnv];
};

// export const getCyberSourceMerchantId = () => {
//   const cyberSourceMerchantId = {
//     QA: "worksimpli_poc_1706718011",
//     PRODUCTION: "",
//     STAGING: "",
//     DEVELOPMENT: "worksimpli_poc_1706718011",
//   };
//   return cyberSourceMerchantId[currentEnv];
// };

// export const getCyberSourceKey = () => {
//   const cyberSourceKey = {
//     QA: "e512f753-76bd-4e3b-ae12-9eb21c333bb6",
//     PRODUCTION: "",
//     STAGING: "",
//     DEVELOPMENT: "e512f753-76bd-4e3b-ae12-9eb21c333bb6",
//   };
//   return cyberSourceKey[currentEnv];
// };

// export const getCyberSourceSecretKey = () => {
//   const cyberSourceSecretKey = {
//     QA: "3mPX7oaKwfgI/LOn2Gr9qUVvV4lQpR5Tcb6LShj2RMY=",
//     PRODUCTION: "",
//     STAGING: "",
//     DEVELOPMENT: "3mPX7oaKwfgI/LOn2Gr9qUVvV4lQpR5Tcb6LShj2RMY=",
//   };
//   return cyberSourceSecretKey[currentEnv];
// };
//export const KountApiKey="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiIxMDE0NTIiLCJhdWQiOiJLb3VudC4xIiwiaWF0IjoxNjkwMTg4OTg2LCJzY3AiOnsia2EiOm51bGwsImtjIjpudWxsLCJhcGkiOnRydWUsInJpcyI6dHJ1ZSwidGRzIjpudWxsfX0.TZumbcVr194vAIQ-CJS2C08HnltKlOvhZ7fPQZGt_no";
export const getUTCTimeStamp = () => {
  var date = new Date();
  return (
    date.getFullYear() +
    ("0" + (date.getUTCMonth() + 1)).slice(-2) +
    ("0" + date.getUTCDate()).slice(-2) +
    ("0" + date.getUTCHours()).slice(-2) +
    ("0" + date.getUTCMinutes()).slice(-2) +
    ("0" + date.getUTCSeconds()).slice(-2)
  );
};
export const createHmac = () => {
  var concatinatedString =
    getTokenExID() + "|" + window.location.origin + "|" + getUTCTimeStamp() + "|" + getTokenExScheme();
  var hash = CryptoJS.HmacSHA256(concatinatedString, getTokenExSecretKey());
  var hashInBase64 = CryptoJS.enc.Base64.stringify(hash);
  return hashInBase64;
};
